import { createSelector } from '@reduxjs/toolkit';

const mealsData = (state = {}) => state.meals;

export const getMeals = createSelector(mealsData, (mealsData) => mealsData.meals);

export const getLoading = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.loading
);

export const getPageStats = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.stats
);

export const getCreateLoading = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.creating
);

export const getMeal = createSelector(mealsData, (mealsData) => mealsData.meal);

export const getExportData = createSelector(
  mealsData,
  (mealsData) => mealsData.exported
);

export const getMealPreference = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.weekly
);

export const getIngredients = createSelector(
  mealsData,
  (mealsData) => mealsData.ingredients
);

export const getSearching = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.fetching
);

export const creatingIngredientsLoading = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.creating_ingredients
);

export const ingredientList = createSelector(
  mealsData,
  (mealsData) => mealsData.list
);

export const getExportDataForIngredients = createSelector(
  mealsData,
  (mealsData) => mealsData.export_ingredients
);

export const getIngredientsPageStats = createSelector(
  mealsData,
  (mealsData) => mealsData.ingredients_stats
);

export const getWeeklyPreferencePreview = createSelector(
  mealsData,
  (mealsData) => mealsData.preferences
);

export const getLoadingWeekly = createSelector(
  mealsData,
  (mealsData) => mealsData.ui.loadingWeekly
);

export const getTagPreferences = createSelector(
  mealsData,
  (mealsData) => mealsData.tagPreferences
);

export const getFilteredMeals = createSelector(
  mealsData,
  (mealsData) => mealsData.filtered_meals
);
